import React, { useContext, useState } from 'react';
import { groupDataUpdate } from './utils';
import { SetupBoardContext } from '../SetupBoard/SetupBoard';

export interface ICompleteButton {
    configSectionId: string;
    groupData: any;
}

interface ICompleteButton2 extends ICompleteButton {
    isCompleted: boolean;
}

const CompleteButton: React.FC<ICompleteButton2> = ({
    configSectionId,
    groupData,
    isCompleted,
}) => {
    const [completed, setCompleted] = useState(isCompleted);
    const { refreshGroupInformations } = useContext(SetupBoardContext)

    const handleClick = () => {
        const itemToUpdate: any = {};
        itemToUpdate[configSectionId] = !completed;
        groupDataUpdate(groupData, itemToUpdate)
            .then((updatedGroupData) => {
                setCompleted(updatedGroupData[configSectionId]);
            })
            .catch((error) => {
                console.error(error);
            }).finally(() => refreshGroupInformations())

    };

    const buttonLabel = completed ? 'Mark incomplete' : 'Mark complete';

    return (
        <button className='complete-button' onClick={handleClick}>
            {buttonLabel}
        </button>
    );
};

export default CompleteButton;
